var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16 7.06659V28.4399C15.7733 28.4399 15.5333 28.3999 15.3466 28.2933L15.2933 28.2666C12.7333 26.8666 8.26663 25.3999 5.37329 25.0133L4.98663 24.9599C3.70663 24.7999 2.66663 23.5999 2.66663 22.3199V6.21326C2.66663 4.62659 3.95996 3.42659 5.54663 3.55993C8.34663 3.78659 12.5866 5.19993 14.96 6.67993L15.2933 6.87993C15.4933 6.99993 15.7466 7.06659 16 7.06659Z",
    fill: "#FFA940"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 6.22654V22.3199C29.3333 23.5999 28.2933 24.7999 27.0133 24.9599L26.5733 25.0132C23.6667 25.3999 19.1867 26.8799 16.6267 28.2932C16.4533 28.3999 16.24 28.4399 16 28.4399V7.06654C16.2533 7.06654 16.5067 6.99988 16.7067 6.87988L16.9333 6.73321C19.3067 5.23988 23.56 3.81321 26.36 3.57321H26.44C28.0267 3.43988 29.3333 4.62654 29.3333 6.22654Z",
    fill: "#FFA940"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 12.3198H7.33337C6.78671 12.3198 6.33337 11.8665 6.33337 11.3198C6.33337 10.7732 6.78671 10.3198 7.33337 10.3198H10.3334C10.88 10.3198 11.3334 10.7732 11.3334 11.3198C11.3334 11.8665 10.88 12.3198 10.3334 12.3198Z",
    fill: "#FFA940"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 16.3198H7.33337C6.78671 16.3198 6.33337 15.8665 6.33337 15.3198C6.33337 14.7732 6.78671 14.3198 7.33337 14.3198H11.3334C11.88 14.3198 12.3334 14.7732 12.3334 15.3198C12.3334 15.8665 11.88 16.3198 11.3334 16.3198Z",
    fill: "#FFA940"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook2);
export default __webpack_public_path__ + "static/media/book_2.fff24c60c036bcf9e062f920d801f23b.svg";
export { ForwardRef as ReactComponent };